export function getPaymentMedium(paymentMediums: string[]) {
  return paymentMediums.find((paymentMedium) => {
    if (paymentMedium.length === 0) {
      return false;
    }
    return paymentMedium;
  });
}
